
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTopicMaterialBundle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"landingpageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topicMaterialBundle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"landingpageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"landingpageId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topicBundleId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topicName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publishedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"complete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approvable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blockedMembers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"failedMembers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"missingMembers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pendingReviewMembers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incompleteMembers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"missingFields"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"replacementInFlight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diagnosticsAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"variantIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"materialId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publishedVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"candidateVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"candidateChecksum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"candidateFile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"quality"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"warningCount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"replacementInFlight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attemptCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastAttemptAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastFailureCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastFailureMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"missingFields"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diagnosticsAvailable"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":896}};
    doc.loc.source = {"body":"query getTopicMaterialBundle($companyId: ID!, $landingpageId: ID!) {\n  topicMaterialBundle(companyId: $companyId, landingpageId: $landingpageId) {\n    topicBundleId\n    topicName\n    expectedCount\n    publishedCount\n    complete\n    approvable\n    blockedMembers\n    failedMembers\n    missingMembers\n    pendingReviewMembers\n    incompleteMembers\n    missingFields\n    replacementInFlight\n    diagnosticsAvailable\n    members {\n      key\n      assetType\n      variantIndex\n      materialId\n      displayName\n      state\n      publishedVersion\n      candidateVersion\n      candidateChecksum\n      candidateFile {\n        id\n        cdnUrl\n      }\n      quality {\n        passed\n        errorCount\n        warningCount\n      }\n      replacementInFlight\n      attemptCount\n      lastAttemptAt\n      lastFailureCode\n      lastFailureMessage\n      missingFields\n      diagnosticsAvailable\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getTopicMaterialBundle"] = oneQuery(doc, "getTopicMaterialBundle");
        
